<template>
    <div class="admin">
        <form style="margin-bottom:10px;">
            <a-row type="flex" justify="start">
                <a-col :span="8">
                    <a-row :gutter="10">
                        <a-col :span="11">
                            <a-input v-model="keyword" placeholder="请输入分类名称" />
                        </a-col>
                        <a-col :span="3">
                            <a-button type="primary" @click="get_data()">搜索</a-button>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="2">
                    <a-button
                        type="primary"
                        @click="add_model = true; info_add = { status: 1, sort: 0, short_name: '' }"
                        v-if="$Func.check_rank('lithium_add')"
                    >添加分类</a-button>
                </a-col>
            </a-row>
        </form>
        <a-table
            :columns="columns"
            :data-source="tableData"
            @change="change_filter"
            :loading="loading"
            :pagination="page"
            bordered
        >
            <template slot="icon_tpl" slot-scope="text">
                <img v-if="text" :src="base_url + text" style="width:40px;height:40px;object-fit:contain;" />
                <span v-else>-</span>
            </template>
            <template slot="status_tpl" slot-scope="text">
                <a-tag :color="text == 1 ? 'green' : 'red'">
                    {{ text == 1 ? '启用' : '禁用' }}
                </a-tag>
            </template>
            <template slot="operation" slot-scope="text, record">
                <a @click="() => { update_data(record) }" v-if="$Func.check_rank('lithium_edit')">编辑</a>
                <a-divider type="vertical" />
                <a @click="() => { delete_data(record) }" v-if="$Func.check_rank('lithium_del')">删除</a>
            </template>
        </a-table>
        <a-drawer
            title="锂电市场分类"
            :width="450"
            :maskStyle="{ backgroundColor: '#00000010' }"
            :visible="add_model"
            :body-style="{ paddingBottom: '80px' }"
            @close="add_model = false"
        >
            <a-form-model :model="info_add" :rules="add_rules" layout="vertical" @submit="add_data" ref="add_form">
                <a-form-model-item ref="name" prop="name" label="分类名称">
                    <a-input v-model="info_add.name" placeholder="请输入分类名称" />
                </a-form-model-item>
                <a-form-model-item ref="short_name" prop="short_name" label="分类简称">
                    <a-input v-model="info_add.short_name" placeholder="请输入分类简称（可选）" />
                </a-form-model-item>
                <a-form-model-item ref="icon" label="分类图标">
                    <div class="icon-upload-wrap">
                        <div class="icon-preview-box" v-if="icon_preview">
                            <img :src="icon_preview" class="icon-preview-img" />
                            <a-icon type="close" class="icon-remove" @click="remove_icon" />
                        </div>
                        <a-upload
                            v-else
                            list-type="picture-card"
                            :show-upload-list="false"
                            :custom-request="icon_upload"
                            accept="image/*"
                        >
                            <div>
                                <a-icon type="plus" />
                                <div class="ant-upload-text">上传图标</div>
                            </div>
                        </a-upload>
                        <span class="icon-tip">建议 1:1 正方形图片，点击右上角可删除</span>
                    </div>
                    <a-input v-model="info_add.icon" placeholder="图标URL（上传后自动填充）" style="margin-top:8px;" />
                </a-form-model-item>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item ref="sort" label="排序">
                            <a-input-number style="width: 100%" :min="0" v-model="info_add.sort" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="status" label="状态">
                            <a-switch
                                v-model="info_add.status"
                                :checked="info_add.status == 1"
                                :checked-children="'启用'"
                                :un-checked-children="'禁用'"
                                @change="(val) => { info_add.status = val ? 1 : 0 }"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <div
                    :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1,
                    }"
                >
                    <a-button :style="{ marginRight: '8px' }" @click="add_model = false">取消</a-button>
                    <a-button type="primary" html-type="submit">确定</a-button>
                </div>
            </a-form-model>
        </a-drawer>
    </div>
</template>

<script>
import Func from '../../common/func';

const columns = [
    { title: '#', dataIndex: 'id', key: 'id', width: 80 },
    { title: '分类名称', dataIndex: 'name', key: 'name' },
    { title: '分类简称', dataIndex: 'short_name', key: 'short_name', width: 120 },
    { title: '图标', dataIndex: 'icon', key: 'icon', width: 80, scopedSlots: { customRender: 'icon_tpl' } },
    { title: '排序', dataIndex: 'sort', key: 'sort', width: 80 },
    { title: '状态', dataIndex: 'status', key: 'status', width: 80, scopedSlots: { customRender: 'status_tpl' } },
    { title: '操作', dataIndex: 'id', width: 150, key: 'operation', scopedSlots: { customRender: 'operation' } },
];

export default {
    name: 'LithiumCategory',
    data() {
        return {
            base_url: Func.pic_url,
            columns,
            keyword: '',
            tableData: [],
            loading: false,
            add_model: false,
            info_add: { status: 1, sort: 0, short_name: '' },
            add_rules: {
                name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
            },
            page: { current: 1, total: 0, pageSize: 10 },
        };
    },
    computed: {
        icon_preview() {
            if (!this.info_add.icon) return '';
            return this.info_add.icon.indexOf('http') === 0
                ? this.info_add.icon
                : this.base_url + this.info_add.icon;
        },
    },
    mounted() {
        this.get_data();
    },
    methods: {
        change_filter(pagination) {
            this.get_data(pagination.current);
        },
        get_data(page, tip) {
            if (!page) page = this.page.current || 1;
            if (!tip) this.loading = true;

            Func.url_get(
                {
                    action: 'lithium.index',
                    keyword: this.keyword,
                    page: page,
                },
                (res) => {
                    if (res.error === 0) {
                        this.tableData = res.info.list;
                        this.page = {
                            pageSize: 10,
                            total: res.info.foot.total,
                            current: parseInt(res.info.foot.current),
                        };
                        this.loading = false;
                    } else {
                        this.$message.error(res.info);
                    }
                }
            );
        },
        icon_upload(options) {
            const file = options.file;
            Func.url_form(
                { action: 'api.ed_upload', imgFile: file },
                (res) => {
                    if (res.error === 0) {
                        this.info_add.icon = res.url;
                        this.$message.success('图标上传成功');
                        if (options.onSuccess) options.onSuccess(res);
                    } else {
                        this.$message.error(res.info);
                        if (options.onError) options.onError(res);
                    }
                }
            );
        },
        remove_icon() {
            this.info_add.icon = '';
        },
        add_data(e) {
            e.preventDefault();
            this.$refs.add_form.validate((valid) => {
                if (valid) {
                    Func.url_post(
                        {
                            action: this.info_add.id ? 'lithium.save_data' : 'lithium.add_data',
                            ...this.info_add,
                        },
                        (res) => {
                            if (res.error === 0) {
                                this.$message.success(res.info);
                                this.add_model = false;
                                this.get_data(1, true);
                            } else {
                                this.$message.error(res.info);
                            }
                        }
                    );
                }
            });
        },
        update_data(record) {
            const item = JSON.parse(JSON.stringify(record));
            Func.url_get({ action: 'lithium.find_data', id: item.id }, (res) => {
                if (res.error !== 0) {
                    this.$message.error(res.info);
                    return;
                }
                this.info_add = res.info;
                this.add_model = true;
            });
        },
        delete_data(item) {
            if (confirm('确定要删除该分类吗？') == true) {
                Func.url_get({ action: 'lithium.del_data', id: item.id }, (res) => {
                    if (res.error === 0) {
                        this.$message.success(res.info);
                        this.get_data(1, true);
                    } else {
                        this.$message.error(res.info);
                    }
                });
            }
        },
    },
};
</script>

<style scoped>
.icon-upload-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
}
.icon-preview-box {
    position: relative;
    width: 72px;
    height: 72px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
    background: #fafafa;
    flex: 0 0 72px;
}
.icon-preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.icon-remove {
    position: absolute;
    top: 0;
    right: 0;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.55);
    cursor: pointer;
}
.icon-tip {
    color: #999;
    font-size: 12px;
    line-height: 1.4;
}
.icon-upload-wrap >>> .ant-upload.ant-upload-select-picture-card {
    width: 72px;
    height: 72px;
    margin: 0;
    flex: 0 0 72px;
}
</style>
